import React, { useState } from 'react'
import LoginForm from './loginForm'
import RecoveryForm from './recoveryForm'
import Alert from './alert'

const LandingPage = props => {
  const [forgotPassword, setForgotPassword] = useState(false)
  const [alert, setAlert] = useState(null)
  const [alertClass, setAlertClass] = useState('')

  const showAlert = (text) => {
    setAlert(text)
    setAlertClass('open-alert')
  }

  const loginForm = () => {
    return (
      <LoginForm
        authenticityToken={props.authenticity_token}
        onRecovery={() => setForgotPassword(true)}
        onError={(text) => showAlert(text)}
      />
    )
  }
  const recoveryForm = () => {
    return (
      <RecoveryForm
        onExit={() => setForgotPassword(false)}
        authenticityToken={props.authenticity_token}
      />
    )
  }

  return (
    <div className='landing-wrapper'>
      { forgotPassword ? recoveryForm() : loginForm() }
      { alert &&
        <Alert
          className={alertClass}
          text={alert}
          onHide={() => setAlertClass('close-alert')}
          onRemove={() => setAlert(null)}
        />
      }
    </div>
  )
}

export default LandingPage
